import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAddressDetails, getDropDownValues, getOrderByTrackingNumber, getOrdersByUserAndBU, loadMoreAddresses, registerNewUser, submitFreightOrderRequest } from "../service/APIService";
import { RootState } from "./store";

const initialState: any = {
    isLoading: false,
    selectedBu: ''
};

export const masterDataSlice = createSlice({
    name: 'masterDataSlice',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading = true;
        },
        stopLoading: (state) => {
            state.isLoading = false;
        },
        setBusinessUnit: (state, action) => {
            state.selectedBu = action.payload;
        }
    },
    extraReducers: (builder: any) => {

    }
});

export const { startLoading, stopLoading, setBusinessUnit } = masterDataSlice.actions;


export default masterDataSlice.reducer;

export const getLoaderState = (state: RootState) => state.masterDataSlice.isLoading;

export const getBusinessUnit = (state: RootState) => state.masterDataSlice.selectedBu;



export const registerExternalUser = createAsyncThunk('registerExternalUser',
    async (payload: any) => {
        const response = await registerNewUser(payload);
        return response
    }
)

export const fetchDropDownValues = createAsyncThunk('fetchDropDownValues',
    async () => {
        const response = await getDropDownValues();
        return response
    }
)

export const fetchExistingOrders = createAsyncThunk('fetchExistingOrders',
    async (payload: any) => {
        const response = await getOrdersByUserAndBU(payload);
        return response
    }
)

export const fetchOrderByTrackingNumber = createAsyncThunk('fetchOrderByTrackingNumber',
    async (payload: any) => {
        const response = await getOrderByTrackingNumber(payload);
        return response
    }
)

export const searchAddressOnType = createAsyncThunk('searchAddressOnType',
    async (payload: any) => {
        const response = await getAddressDetails(payload);
        return response
    }
)

export const searchMoreAddressOnScroll = createAsyncThunk('searchMoreAddressOnScroll',
    async (payload: any) => {
        const response = await loadMoreAddresses(payload.reqBody, payload.abortObj);
        return response
    }
)

export const createFreightOrder = createAsyncThunk('createFreightOrder',
    async (payload: any) => {
        const response = await submitFreightOrderRequest(payload);
        return response
    }
)